<template>
    <div>
        <div class="answer" v-if="item" @click="godetail(item)">
                <div class="answerlist-header"> 
                <div class="answerlist-header-img" @click.stop="gotomy(item)">
                    <img :src="$baseurl+item.headImg" v-if="item.headImg">
                </div>
                <div class="answerlist-header-wz">
                    <div class="answerlist-header-wz-tit">{{item.nick}}</div>
                    <div class="answerlist-header-wz-stit" v-if="item.signature">{{item.signature}}</div>
                    <div class="answerlist-header-wz-stit" v-if="!item.signature">未设置</div>
                </div>
            </div>
            <div class="answerlist-content">
                {{item.content}}
            </div>
            <div class="answerlist-time" v-if="showtime">
                {{item.creationTime}}
            </div>
            <div class="answerlist-icons" v-if="showicons">
                <div class="answerlist-icon" >
                    <van-icon
                        class="answerlist-icon-icon2"
                        :size="18"
                        class-prefix="abc-icon"
                        name="pinglun8"
                    />
                    <span>{{item.commentCount}}</span>
                </div>
                <div class="answerlist-icon" @click.stop="like(item)">
                     <van-icon
                            class="answerlist-icon-icon3"
                            :size="18"
                            name="like-o"
                            v-if="!item.isLike"
                        />
                         <van-icon
                            class="answerlist-icon-icon3"
                            :size="18"
                            name="like"
                            v-if="item.isLike"
                            color="red"
                        />
                    <span>{{item.giveLikeCount}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'comanswerlist',
    props:{
        showicons:{
            type:Boolean,
            default:false
        },
        showtime:{
            type:Boolean,
            default:false
        },
        item:{
            type:Object,
            default:undefined
        },
        title:{
            type:String,
            default:''
        }
    },
    data(){
        return {

        }
    },
    created(){

    },
    methods:{
        gotomy(item){
            this.$router.push({path:'/communitymy',query:{id:item.memberPersonalId}});
        },
        godetail(item){
            console.log(this.title);
            var itemjson=JSON.stringify(item);
            this.$router.push({path:'/answerdetail',query:{item:itemjson,title:this.title}});
        },
        like(item)
        {
            this.$emit('like',item);
        }
    }
    
}
</script>
<style lang="scss" scoped>
.answerlist-header{
    padding-left:50px;
    padding-right:30px;
    position: relative;
    min-height: 45px;
    line-height: 23px;
    margin-bottom: 10px;
}
.answerlist-header-img{
    position: absolute;
    left:0;
    width: 40px;
    height: 40px;
}
.answerlist-header-img img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.answerlist-header-wz-tit{
    font-size: 14px;
}
.answerlist-header-wz-stit{
    font-size: 12px;
    color:#a8a8a8;
}
.answerlist-content{
    font-size: 14px;
    word-break: break-all;
    line-height: 23px;
    margin-bottom: 10px;
}

.answerlist-time{
    color:#d4d4d4;
    margin-bottom: 10px;
}

.answerlist-icons{
    display: flex;
    text-align: center;
    line-height: 25px;
    .answerlist-icon{
        width: 50%;
    }
    .answerlist-icon-icon1{
        vertical-align: -2px;
        margin-right: 2px;
    }
    .answerlist-icon-icon2{
        vertical-align: -1px;
        margin-right: 4px;
    }
    .answerlist-icon-icon3{
        vertical-align: -3px;
        margin-right: 4px;
    }
}
</style>